import { useEffect, useRef, useState } from "react";

/** Animated counter that counts from 0 → target when in view. */
export function StatCounter({ value, suffix = "", prefix = "", decimals = 0, duration = 1400 }) {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    if (!ref.current) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const target = Number(value) || 0;
          const startTs = performance.now();
          const tick = (ts) => {
            const t = Math.min(1, (ts - startTs) / duration);
            const eased = 1 - Math.pow(1 - t, 3);
            setN(target * eased);
            if (t < 1) requestAnimationFrame(tick);
            else setN(target);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.3 });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [value, duration]);

  return (
    <span ref={ref} className="font-display font-semibold gradient-text tabular-nums">
      {prefix}{decimals > 0 ? n.toFixed(decimals) : Math.round(n).toLocaleString()}{suffix}
    </span>
  );
}
